module.exports = __webpack_public_path__ + "img/business-icon.e269375f.svg";